/* ===========================================================
   lib/markdown.js — doc JSON ⇄ Markdown (loaded only when needed)

   Uses TipTap's own Markdown manager with the same extensions as the
   editor, so equations ($…$, $$…$$), checklists, tables, code fences
   and the sandbox (:::sandbox) all round-trip.
   =========================================================== */

import { MarkdownManager } from '@tiptap/markdown';
import { docExtensions } from '../editor/extensions.js';
import { normalize } from '../editor/convert.js';

let mgr = null;
const manager = () => (mgr ||= new MarkdownManager({ extensions: docExtensions() }));

export function toMarkdown(json) {
  return manager().serialize(normalize(json)).replace(/\n{3,}/g, '\n\n').trimEnd() + '\n';
}

export function fromMarkdown(md) {
  return normalize(manager().parse(String(md || '')));
}

/** Plain text → paragraphs (one per line; blank lines kept as empty paragraphs). */
export function fromText(text) {
  const lines = String(text || '').replace(/\r\n?/g, '\n').split('\n');
  return normalize({ type: 'doc', content: lines.map(l => ({ type: 'paragraph', content: l ? [{ type: 'text', text: l }] : [] })) });
}

/** A code file → one code block, so it still looks like a doc. */
export function fromCode(text, language) {
  const body = String(text || '').replace(/\r\n?/g, '\n');
  return normalize({ type: 'doc', content: [{ type: 'codeBlock', attrs: { language }, content: body ? [{ type: 'text', text: body }] : [] }] });
}
